exports = module.exports = require("../../../../css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".v-input--checkbox.v-input--indeterminate.v-input--is-disabled{opacity:.6}", "", {"version":3,"sources":["/home/circleci/repo/node_modules/vuetify/src/components/VCheckbox/VCheckbox.sass","/home/circleci/repo/node_modules/vuetify/src/components/VCheckbox/_variables.scss"],"names":[],"mappings":"AAII,+DACE,UCHsB,CAAA","file":"VCheckbox.sass","sourcesContent":["@import './_variables.scss'\n\n.v-input--checkbox\n  &.v-input--indeterminate\n    &.v-input--is-disabled\n      opacity: $checkbox-disabled-opacity\n","@import '../../styles/styles.sass';\n\n$checkbox-disabled-opacity: .6 !default;\n"],"sourceRoot":""}]);

// exports
